<footer class="adv-footer noprint">
  <div class="adv-footer-inner">

    <!-- Logo + Tagline -->
    <div class="adv-footer-brand">
      <a routerLink="/" class="adv-footer-logo">
        <svg width="26" height="26" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="28" height="28" rx="7" fill="#22c55e" fill-opacity="0.15"/>
          <path d="M7 20L14 8L21 20" stroke="#22c55e" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.5 16H18.5" stroke="#22c55e" stroke-width="1.8" stroke-linecap="round"/>
        </svg>
        <div>
          <span class="adv-footer-wordmark">ADVENT<span>UM</span></span>
          <span class="adv-footer-sub">Calculators</span>
        </div>
      </a>
      <p class="adv-footer-tagline">Professional financial calculators for property investors worldwide.</p>
      <div class="adv-footer-social">
        <a href="https://twitter.com/login" target="_blank" aria-label="Twitter"><i class="fa fa-twitter"></i></a>
        <a href="https://www.facebook.com/" target="_blank" aria-label="Facebook"><i class="fa fa-facebook"></i></a>
        <a href="https://www.instagram.com/accounts/login" target="_blank" aria-label="Instagram"><i class="fa fa-instagram"></i></a>
      </div>
    </div>

    <!-- Calculators -->
    <div class="adv-footer-col">
      <h6 class="adv-footer-heading">Calculators</h6>
      <ul class="adv-footer-links">
        <li><a (click)="next(1)" style="cursor:pointer;">Investment Property</a></li>
        <li><a (click)="next(6)" style="cursor:pointer;">Cashflow Calculator</a></li>
        <li><a (click)="next(2)" style="cursor:pointer;">Capital Growth</a></li>
        <li><a (click)="next(3)" style="cursor:pointer;">Estimated Weekly Rent</a></li>
        <li><a (click)="next(4)" style="cursor:pointer;">Predictive Forex</a></li>
        <li><a (click)="next(5)" style="cursor:pointer;">Stamp Duty</a></li>
        <li><a (click)="next(7)" style="cursor:pointer;">ATED Calculator</a></li>
      </ul>
    </div>

    <!-- Company -->
    <div class="adv-footer-col">
      <h6 class="adv-footer-heading">Company</h6>
      <ul class="adv-footer-links">
        <li><a routerLink="/about">About</a></li>
        <li><a href="https://www.adventumwealth.com/#return-to-top" target="_blank">Contact</a></li>
        <li><a routerLink="/login">Login</a></li>
        <li><a routerLink="/register">Register</a></li>
      </ul>
    </div>

    <!-- Subscribe -->
    <div class="adv-footer-col adv-footer-subscribe">
      <h6 class="adv-footer-heading">Stay Updated</h6>
      <p class="adv-footer-subscribe-text">Subscribe for news and latest updates. No spam, ever.</p>
      <div class="adv-footer-subscribe-row">
        <input type="text" placeholder="Your email address" class="adv-footer-input">
        <button class="adv-footer-subscribe-btn" type="button">Subscribe</button>
      </div>
    </div>

  </div>

  <!-- Bottom bar -->
  <div class="adv-footer-bottom">
    <span class="adv-footer-copy">© 2026 Adventum Calculators. All rights reserved.</span>
    <div class="adv-footer-legal">
      <a href="#">Privacy Policy</a>
      <a href="#">Terms &amp; Conditions</a>
      <a href="#">Site Map</a>
    </div>
  </div>
</footer>

<!-- ── MOBILE NAV MODAL (shared with navigation) ── -->
<div id="navbar-modal" class="modal fade" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <div class="adv-modal-logo" style="display:flex;align-items:center;gap:10px;justify-content:center;margin-bottom:28px;">
          <svg width="30" height="30" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="28" height="28" rx="7" fill="#22c55e" fill-opacity="0.15"/>
            <path d="M7 20L14 8L21 20" stroke="#22c55e" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9.5 16H18.5" stroke="#22c55e" stroke-width="1.8" stroke-linecap="round"/>
          </svg>
          <span style="font-family:'Montserrat',sans-serif;font-size:18px;font-weight:700;color:#fff;letter-spacing:2px;background:transparent!important;width:auto!important;height:auto!important;">ADVENT<span style="color:#22c55e;background:transparent!important;width:auto!important;height:auto!important;display:inline!important;">UM</span></span>
        </div>

        <ul class="navmobile-link">
          <li class="main-nav"><a>Calculators</a></li>
          <li class="sub-nav"><a (click)="next(1)" data-dismiss="modal">Investment Property Calculator</a></li>
          <li class="sub-nav"><a (click)="next(6)" data-dismiss="modal">Cashflow Calculator</a></li>
          <li class="sub-nav"><a (click)="next(2)" data-dismiss="modal">Capital Growth Calculator</a></li>
          <li class="sub-nav"><a (click)="next(3)" data-dismiss="modal">Estimated Weekly Rent</a></li>
          <li class="sub-nav"><a (click)="next(4)" data-dismiss="modal">Predictive Foreign Exchange</a></li>
          <li class="sub-nav"><a (click)="next(5)" data-dismiss="modal">Stamp Duty Calculator</a></li>
          <li class="sub-nav"><a (click)="next(7)" data-dismiss="modal">ATED Calculator</a></li>
          <li class="main-nav"><a (click)="next(8)" data-dismiss="modal">About</a></li>
          <li class="main-nav"><a (click)="next(9)" data-dismiss="modal">Login</a></li>
          <li class="main-nav"><a (click)="next(10)" data-dismiss="modal">Register</a></li>
          <li class="main-nav"><a href="https://www.adventumwealth.com/#return-to-top" target="_blank">Contact</a></li>
        </ul>

        <div class="social-links">
          <a href="https://twitter.com/login" target="_blank"><i class="fa fa-twitter"></i></a>
          <a href="https://www.facebook.com/" target="_blank"><i class="fa fa-facebook"></i></a>
          <a href="https://www.google.com/" target="_blank"><i class="fa fa-google"></i></a>
          <a href="https://www.instagram.com/accounts/login" target="_blank"><i class="fa fa-instagram"></i></a>
        </div>

        <div class="privacy-link">
          <ul>
            <li><a href="#" style="color:rgba(255,255,255,0.4);text-decoration:none;">Privacy Policy</a></li>
            <li><a href="#" style="color:rgba(255,255,255,0.4);text-decoration:none;">Terms &amp; Conditions</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
